import { DateHelper } from '../misc/dateHelpers';
import { DateTimeType } from './dateTypes';
import { HistoryItem } from './historyItem';
import { z } from 'zod';

export const BaseItem = z.object({
    /** Unique identifier */
    id: z.string(),
    /** History of all changes done to this item */
    history: z.array(HistoryItem).default([]),
    /** ISO Date when receipt was uploaded */
    createdOn: DateTimeType,
    /** ISO Date when receipt was modified */
    modifiedOn: DateTimeType,
    /** Internal version for concurrency control */
    _v: z.number().nullish(),
});
export type BaseItem = z.infer<typeof BaseItem>;

export function createBaseItem(id: string): BaseItem {
    const date = DateHelper.now();

    return {
        id,
        history: [],
        createdOn: date,
        modifiedOn: date,
    };
}
